import { Col, Row } from "react-bootstrap";
import './SXWYZSIcon.css';

export default function SXWYZSIcon() {

    return (
        <Row id='sxwyzs'>
            <Col>
                <div className="cardStyle d-flex align-items-center justify-content-center">
                    <Row>
                        <Col className="d-flex align-items-center justify-content-center">
                            <span className="textStyle">十二生肖密码 终身</span>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    )
}